'use strict';

import $ from "jquery";
var accuCodeService = null;
var translate = null;
var personalMessagingFactory = null;
var httpProvider = null;


var PersonalMessagingDirective = function (AccuCodeService, $http, $translate, $state, $rootScope, personalMessagingFactory, $cookies) {
  accuCodeService = AccuCodeService;
  translate = $translate;
  personalMessagingFactory = personalMessagingFactory;
  httpProvider = $http;
  return {
    replace: "true",
    restrict: "AE",
    template: `<div id="{{ pmId }}" ng-show="showPM"></div>`,
    scope: {
      heading: '@',
      blueConicData: '@',
      src: '@'
    },
    link: function (scope, element, attr) {
      loadScript(scope, element, attr);



    }
  };


  function loadScript(scope, element, attr) {

    scope.heading = 'Plan Messaging';

    var gaID = null;
    scope.pmId = 'pmHome';
    scope.showPM = false;
    $rootScope.showHeading = false;
    $rootScope.pmEnabled = false;

    /** scope.accu = AccuCodeService.getAccuCode();

    //var gaID = $rootScope.personalMessagingData.planNumber;

    gaID = $cookies.get('PM-PLAN-TOKEN');
    console.log('gaID from Cookie', gaID);



if (gaID)
 {
  console.log('gaID ', gaID);
  var pmParams={
               "accu": scope.accu,
               "groupId" : gaID

                      };

      personalMessagingFactory.isPMEnabled.query(pmParams, function(data, headers) {
      $rootScope.pmEnabled = data.toJSON().eligible;
      console.log('pmEnabled', $rootScope.pmEnabled);
      console.log("accu: " , scope.accu);


    if ($rootScope.pmEnabled){
    scope.showPM = true;
    $rootScope.showHeading = true;
    if (scope.src === 'Deferrals')
    {
      if($state.current.data && $state.current.data.inEnrollment)
        {
          scope.showPM = false;
        }
      scope.pmId = 'pmDef';
    }



     var bcHostname = "gw.sb.blueconic.net";
      var protocol = (("https:" == document.location.protocol) ? "https://" : "http://");



      var envCfgPath = "/participant_env.json";
    httpProvider.get(envCfgPath)
      .then(function(response) {
          console.log('PersonalMessaging: response',response);
          var data = response.data;
          if (data.personalMessaging && data.personalMessaging.blueconicURL){
               url = data.personalMessaging.blueconicURL;
          }else{
               console.error('personalMessaging: env-specific configuration found but no \"personalMessaging\" specified',response);
          }

}, function errorCallback(response) {
              console.error('PersonalMessaging: Error retrieving env config',envCfgPath,response);

       });

        var url =  protocol + bcHostname + '/frontend/static/javascript/blueconic/blueconic.min.js';
            var type = 'text/javascript';
           if (url) {
              var script = document.querySelector("script[src*='"+url+"']");
               if (!script) {
          var heads = document.getElementsByTagName("head");
          if (heads && heads.length) {
              var head = heads[0];
              if (head) {
                  script = document.createElement('script');
                  script.setAttribute('src', url);
                  script.setAttribute('type', type);
                  script.setAttribute('async', true);
                  head.appendChild(script);
              }
          }
          document.body.appendChild(script);
      }

  }

}
},
function(response) {
throw new Error("personal-messaging directive: Transaction request failed");
});
    }*/
  }





};

PersonalMessagingDirective.$inject = ['AccuCodeService', '$http', '$translate', '$state', '$rootScope', 'personalMessagingFactory', '$cookies'];

export default PersonalMessagingDirective;
